import { render, staticRenderFns } from "./PmtaEmailTest.vue?vue&type=template&id=71266941&scoped=true"
import script from "./PmtaEmailTest.vue?vue&type=script&lang=js"
export * from "./PmtaEmailTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71266941",
  null
  
)

export default component.exports